import { render, staticRenderFns } from "./PickResponsibilityToIssueABadgeDialog.vue?vue&type=template&id=01f29049&scoped=true"
import script from "./PickResponsibilityToIssueABadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PickResponsibilityToIssueABadgeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PickResponsibilityToIssueABadgeDialog.vue?vue&type=style&index=0&id=01f29049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f29049",
  null
  
)

export default component.exports